import './MemberServiceAccount.scss';
import Lock from '../../img/Lock.svg';
import useAccountUnlockScreen from './hooks/useAccountUnlockScreen';
import SkeletonAccountLockedSkeleton from './skeletons/SkeletonAccountUnlockScreen';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';

const AccountUnlockScreen = () => {
  const {
    emailValue,
    EnableSelfUnlock,
    EligiblePersona,
    isLoading,
    isServerError,
    navigate,
    headingRef,
  } = useAccountUnlockScreen();

  if (!emailValue) {
    navigate('/member');
    return null;
  }

  return isLoading ? (
    <SkeletonAccountLockedSkeleton />
  ) : isServerError ? (
    <CustomClientError
      ErrorHeading="Something went wrong with request!"
      ErrorMessage="Please try again."
      CustomClasses="p-0"
    />
  ) : (
    <div className="account-locked-page">
      <div className="account-locked-content">
        <div>
          <img className="help-card-logo" src={Lock} alt="logo" />
        </div>
        <div
          role="heading"
          aria-level={1}
          className="sr-only"
          tabIndex={-1}
          ref={headingRef}
        >
          Your account has been locked due to too many invalid login attempts
        </div>
        <h1 aria-hidden={true} className="account-locked-title">
          Your account has been locked due to
          <br />
          too many invalid login attempts
        </h1>

        {EligiblePersona && EnableSelfUnlock ? (
          <p className="account-locked-description">
            You have reached the maximum number of sign in attempts allowed.
          </p>
        ) : (
          <p className="account-locked-description">
            Get in touch with Customer Care to unlock your account.
          </p>
        )}

        {EligiblePersona && EnableSelfUnlock && (
          <div className="account-locked-action">
            <button
              type="button"
              className="unlock-account-btn"
              onClick={() => {
                navigate('/member/account-unlock-recovery', {
                  state: {
                    email: emailValue,
                  },
                });
              }}
            >
              UNLOCK ACCOUNT
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountUnlockScreen;
